import { Box } from "@mui/material";
import React, { useEffect } from 'react';
import {
    useRouteMatch,
} from "react-router-dom";


export default function Authentication() {

    let {url}  = useRouteMatch();

    let urlParts = url.split ('/');
    let page = urlParts.length > 1 ? urlParts[1].toLowerCase() : "unknown"

    // eslint-disable-next-line
    const [userInfo, setUserInfo] = React.useState({ name : "", email : "", id : ""});


    useEffect(() => {


    },[userInfo]);


    switch (page) {
        case "login":
            return (
                <Box>
                    Login...
                </Box>
            );
        case "logout":
            return (
                <Box>
                    Logout...
                </Box>
            );
        case "authenticate":
            return (
                <Box>
                    Loading...
                </Box>
            );
        case "checkauthenticated":
            return (
                <Box>
                    Checking Authenticated {userInfo.email}...
                </Box>
            );
        default:
            break;
    }



    return (
        <div>
            Authentication
        </div>

    );
}
